export const getAgeGroup = (age: number, withPlus?: boolean): string => {
  const suffix = withPlus ? '+' : 's';

  if (age >= 90) return `90${suffix}`;
  if (age >= 80) return `80${suffix}`;
  if (age >= 70) return `70${suffix}`;
  if (age >= 60) return `60${suffix}`;
  if (age >= 50) return `50${suffix}`;
  if (age >= 40) return `40${suffix}`;
  if (age >= 30) return `30${suffix}`;
  if (age >= 20) return `20${suffix}`;
  if (age >= 18) return `${age}${suffix}`;
};
